<template>
  <div class="card pt-4 pb-5 mb-5 px-4">
    <div class="section-title mb-3">Detección de Picos Altos y Bajos de Comandas</div>
    <div v-if="highlights" class="highlights-grid mt-4 mb-3">
      <div class="highlight-card" style="background: #fef2f2; color: #991b1b;">
        <div class="highlight-title">Pico Alto</div>
        <div class="highlight-main">
          {{ formatLabel(highlights.highPeak.label) }} - {{ highlights.highPeak.detail }}
        </div>
      </div>
      <div class="highlight-card" style="background: #eff6ff; color: #1e3a8a;">
        <div class="highlight-title">Valle Bajo</div>
        <div class="highlight-main">
          {{ formatLabel(highlights.lowValley.label) }} - {{ highlights.lowValley.detail }}
        </div>
      </div>
      <div class="highlight-card" style="background: #ecfdf5; color: #065f46;">
        <div class="highlight-title">Media</div>
        <div class="highlight-main">{{ highlights.avg.label }}</div>
        <div class="highlight-sub">{{ highlights.avg.detail }}</div>
      </div>
    </div>

    <div style="height: 360px;">
      <highcharts :options="chartData" />
    </div>
  </div>
</template>

<script>
  import { makeOrdersTimeseries } from "@/charts/configFactory.js";

  export default {
    name: "OrdersPeaksCard",
    props: {
      highlights: Object,
      chartData: Object,
      scope: String,
      startDate: String,
      endDate: String,
    },
    computed: {
      chartOptions() {
        return makeOrdersTimeseries({
          data: this.chartData?.data || this.chartData || [],
          startDate: this.startDate,
          endDate: this.endDate,
          scope: this.scope,
          color: "#b9a9ff",
          yTitle: "Pedidos",
        });
      },
    },
    methods: {
      formatLabel(dateString) {
        if (!dateString) return "Periodo desconocido";
        const d = new Date(dateString.replace(" ", "T"));

        if (isNaN(d.getTime())) return dateString;

        let opts;
        switch (this.scope) {
          case "quarter":
            opts = { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" };
            break;
          case "hour":
            opts = { day: "2-digit", month: "short", hour: "2-digit" };
            break;
          case "day":
            opts = { day: "2-digit", month: "short" };
            break;
          case "month":
            opts = { month: "long", year: "numeric" };
            break;
          case "year":
            opts = { year: "numeric" };
            break;
          default:
            opts = { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" };
        }

        return d.toLocaleString("es-ES", opts).replace(",", "");
      },
    },
  };
</script>
<style scoped>
  .highlights-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 18px;
    margin-top: 10px;
  }

  .highlight-card {
    border-radius: 14px;
    padding: 16px 20px;
    text-align: center;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.03);
    font-family: "Inter", sans-serif;
  }

  .highlight-title {
    font-weight: 600;
    margin-bottom: 6px;
  }

  .highlight-main {
    font-size: 15px;
    font-weight: 700;
  }

  .highlight-sub {
    font-size: 13px;
    color: #4b5563;
    margin-top: 2px;
  }
</style>